// Tall Tail Coffee — minimal theme JS
// Easter egg toggle on click
document.addEventListener('click', function (e) {
  var egg = e.target.closest('.tt-egg');
  if (!egg) return;
  egg.classList.toggle('is-open');
});

document.addEventListener('click', function (e) {
  var menuToggle = e.target.closest('.tt-header__menu-toggle');

  if (menuToggle) {
    var menuId = menuToggle.getAttribute('aria-controls');
    var menu = menuId ? document.getElementById(menuId) : null;
    if (!menu) return;

    var isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    menu.hidden = isOpen;
    menu.classList.toggle('is-open', !isOpen);
    return;
  }

  document.querySelectorAll('.tt-header__menu-toggle[aria-expanded="true"]').forEach(function (toggle) {
    var controlledId = toggle.getAttribute('aria-controls');
    var controlledMenu = controlledId ? document.getElementById(controlledId) : null;
    if (!controlledMenu) return;

    if (controlledMenu.contains(e.target)) return;

    toggle.setAttribute('aria-expanded', 'false');
    controlledMenu.hidden = true;
    controlledMenu.classList.remove('is-open');
  });
});

document.querySelectorAll('[data-product-form]').forEach(function (form) {
  var variantDataNode = form.parentElement.querySelector('[data-product-variants]');
  if (!variantDataNode) return;

  var variants;
  try {
    variants = JSON.parse(variantDataNode.textContent);
  } catch (err) {
    return;
  }

  var optionGroups = form.querySelectorAll('fieldset[data-option-position]');
  var optionButtons = form.querySelectorAll('[data-option-button]');
  var variantIdInput = form.querySelector('[data-variant-id-input]');
  var addToCartLabel = form.querySelector('[data-add-to-cart-label]');
  var submitButton = form.querySelector('button[type="submit"]');
  var priceNode = form.parentElement.querySelector('.tt-product-price');
  var comparePriceNode = form.parentElement.querySelector('.tt-product-compare-price');
  var unavailableMessage = form.querySelector('[data-product-unavailable-message]');
  var productImage = form.parentElement.parentElement.querySelector('[data-product-image]');

  function getSelectedOptions() {
    var selected = [];

    optionGroups.forEach(function (group) {
      var activeButton = group.querySelector('.tt-product-option-button.is-selected');
      if (activeButton) {
        selected.push(activeButton.getAttribute('data-option-value'));
      }
    });

    return selected;
  }

  function findVariant(selectedOptions) {
    return variants.find(function (variant) {
      if (!variant.options || variant.options.length !== selectedOptions.length) return false;
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });
  }

  function formatMoney(cents) {
    return ((cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD'
    });
  }

  function updateUI() {
    var selectedOptions = getSelectedOptions();
    if (optionGroups.length && selectedOptions.length !== optionGroups.length) return;

    var variant = findVariant(selectedOptions);

    if (!variant) {
      if (variantIdInput) variantIdInput.value = '';
      if (submitButton) submitButton.disabled = true;
      if (addToCartLabel) addToCartLabel.textContent = 'Unavailable';
      if (unavailableMessage) unavailableMessage.style.display = 'block';
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;
    if (submitButton) submitButton.disabled = !variant.available;
    if (addToCartLabel) addToCartLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
    if (priceNode) priceNode.textContent = formatMoney(variant.price);
    if (productImage && variant.featured_image && variant.featured_image.src) {
      productImage.src = variant.featured_image.src;
      productImage.alt = variant.featured_image.alt || '';
    }

    if (comparePriceNode) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceNode.textContent = formatMoney(variant.compare_at_price);
        comparePriceNode.style.display = '';
      } else {
        comparePriceNode.style.display = 'none';
      }
    }

    if (unavailableMessage) {
      unavailableMessage.style.display = variant.available ? 'none' : 'block';
    }
  }

  optionButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var position = button.getAttribute('data-option-position');

      form.querySelectorAll('[data-option-button][data-option-position="' + position + '"]').forEach(function (sibling) {
        sibling.classList.remove('is-selected');
        sibling.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      updateUI();
    });
  });

  updateUI();
});

document.addEventListener('click', function (e) {
  var qtyButton = e.target.closest('[data-cart-qty-button]');
  if (!qtyButton) return;

  var targetId = qtyButton.getAttribute('data-target-input');
  var input = document.getElementById(targetId);
  if (!input) return;

  var currentValue = parseInt(input.value || '0', 10);
  if (isNaN(currentValue)) currentValue = 0;

  if (qtyButton.getAttribute('data-cart-qty-button') === 'increase') {
    input.value = currentValue + 1;
  } else {
    input.value = Math.max(0, currentValue - 1);
  }
});
